import { ChevronDownIcon } from 'lucide-react'

import { cn } from '@/lib/ui/style-helpers'

import { SourceAvatar } from '@/pages/company-drawer/company-overview/set-irq-modal/lema-suggestions-card/source-avatar'
import type { SourceDisplay } from '@/pages/company-drawer/company-overview/set-irq-modal/lema-suggestions-card/types'

type SourceAvatarsIndicatorProps = {
  sources: SourceDisplay[]
  expanded: boolean
}

export const SourceAvatarsIndicator = ({ sources, expanded }: SourceAvatarsIndicatorProps) => (
  <span className='flex shrink-0 items-center gap-2'>
    <span className='flex [&>*:not(:first-child)]:-ml-1'>
      {sources.map((s) => (
        <SourceAvatar key={s.key} label={s.name}>
          {s.icon}
        </SourceAvatar>
      ))}
    </span>
    <ChevronDownIcon
      className={cn(
        'size-4 text-main-foreground-tertiary transition-transform duration-200',
        expanded && 'rotate-180',
      )}
    />
  </span>
)
